import { Component ,Renderer2} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
import { NewsletterService } from '../../../services/newsletter.service';

@Component({
  selector: 'app-newsletter-covers',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './newsletter-covers.component.html',
  styleUrl: './newsletter-covers.component.scss'
})
export class NewsletterCoversComponent {
  constructor(private NewsletterService: NewsletterService,
    private router: Router, 
    private activatedRoute: ActivatedRoute, private render: Renderer2) { }
  nav(url: any) {
    this.router.navigateByUrl(url)
  }
  ngOnInit(): void {
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    )
  }

   newsletters = [
    { 
      month: 'January 2025', 
      imagePath: 'assets/newsletter/jan-letter25.png', 
      postedOn: '03 February 2025', 
      clickMethod: () => this.handleClick('assets/newsletter/jan25.jpg')
    },
    { 
      month: 'December 2024', 
      imagePath: 'assets/newsletter/dec-letter24.jpg', 
      postedOn: '02 January 2025', 
      clickMethod: () => this.handleClick('assets/newsletter/dec24.jpg')
    },
    { 
      month: 'November 2024', 
      imagePath: 'assets/newsletter/november-letter24.webp', 
      postedOn: '03 December 2024', 
      clickMethod: () => this.handleClick('assets/newsletter/november24.jpg')
    },
    { 
      month: 'October 2024', 
      imagePath: 'assets/newsletter/october-letter24.webp', 
      postedOn: '05 November 2024', 
      clickMethod: () => this.handleClick('assets/newsletter/october24.jpg')
    },
    { 
      month: 'September 2024', 
      imagePath: 'assets/newsletter/sep-letter24.webp', 
      postedOn: '30 September 2024', 
      clickMethod: () => this.handleClick('assets/newsletter/sep24.jpg')
    },
    { 
      month: 'August 2024', 
      imagePath: 'assets/newsletter/aug-letter24.webp', 
      postedOn: '30 August 2024', 
      clickMethod: () => this.handleClick('assets/newsletter/aug24.jpg')
    },
    { 
      month: 'July 2024', 
      imagePath: 'assets/newsletter/july-letter24.webp', 
      postedOn: '30 July 2024', 
      clickMethod: () => this.handleClick('assets/newsletter/july24.jpg')
    },
    { 
      month: 'June 2024', 
      imagePath: 'assets/newsletter/june-letter24.webp', 
      postedOn: '28 June 2024', 
      clickMethod: () => this.handleClick('assets/newsletter/june24.jpg')
    },
    { 
      month: 'May 2024', 
      imagePath: 'assets/newsletter/may-letter24.webp', 
      postedOn: '31 May 2024', 
      clickMethod: () => this.handleClick('assets/newsletter/may24.webp')
    },
    { 
      month: 'April 2024', 
      imagePath: 'assets/newsletter/april-letter24.webp', 
      postedOn: '30 April 2024', 
      clickMethod: () => this.handleClick('assets/newsletter/april24.webp')
    },
    { 
      month: 'March 2024', 
      imagePath: 'assets/newsletter/march-letter24.webp', 
      postedOn: '29 March 2024', 
      clickMethod: () => this.handleClick('assets/newsletter/march24.webp')
    },
    { 
      month: 'February 2024', 
      imagePath: 'assets/newsletter/feb-letter24.webp', 
      postedOn: '29 February 2024', 
      clickMethod: () => this.handleClick('assets/newsletter/february24.jpg')
    },
    { 
      month: 'January 2024', 
      imagePath: 'assets/newsletter/jan-letter24.webp', 
      postedOn: '31 January 2024', 
      clickMethod: () => this.handleClick('assets/newsletter/january24.webp')
    },
    { 
      month: 'December 2023', 
      imagePath: 'assets/newsletter/dec-letter23.webp', 
      postedOn: '29 December 2023', 
      clickMethod: () => this.handleClick('assets/newsletter/december23.webp')
    },
    { 
      month: 'November 2023', 
      imagePath: 'assets/newsletter/nov-letter23.webp', 
      postedOn: '30 November 2023', 
      clickMethod: () => this.handleClick('assets/newsletter/november23.webp')
    },
    { 
      month: 'October 2023', 
      imagePath: 'assets/newsletter/oct-letter23.webp', 
      postedOn: '31 October 2023', 
      clickMethod: () => this.handleClick('assets/newsletter/october23.webp')
    },
    { 
      month: 'September 2023', 
      imagePath: 'assets/newsletter/sep-letter23.webp', 
      postedOn: '29 September 2023', 
      clickMethod: () => this.handleClick('assets/newsletter/september23.jpg')
    }
  ];

   handleClick(imagePath: string) {
    localStorage.setItem('selectedImage', imagePath);
    this.router.navigate(['/news-letters/news-month']);
  }

    goHome() {
    this.router.navigate(['/']);
  }
}